<template>
  <b-table class="mt-2" striped hover :fields="fields" :items="rows">
  </b-table>
</template>

<script>
import articles from '@/modules/articles.js'

export default {
  name: 'ArticleReorders',
  props: ["articleid"],
  data() {
    return {
      fields: [
        {label:"Artikel",key:"article"},
        {label:"Text",key:"text"},
        {label:"Menge",key:"count"},
        {label:"Datum",key:"date"}
      ],
      rows: []
    }
  },
  mounted: function() {
    console.log('mounted reorders ' + this.articleid);
    this.fetchData();
  },
  methods: {
    fetchData: function() {
      var self = this;
      console.log('fetch: ' + this.articleid);
      articles.reorders(this.articleid,this,function(data) {
        self.rows = data;
      })
    }
  }
}
</script>
